import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/layout/AgentActivityDrawer.tsx
// Right-side drawer showing a timeline of background agent activity.
import { Drawer } from "../ui/Drawer";
import { AgentChip } from "../ui/AgentChip";
import { ConfidenceBar } from "../ui/ConfidenceBar";
const EVENT_ICONS = {
    started: "○",
    tool_call: "→",
    completed: "✓",
    failed: "✗",
    delegated: "↗",
};
const EVENT_COLORS = {
    started: "text-violet-400",
    tool_call: "text-blue-400",
    completed: "text-emerald-400",
    failed: "text-rose-400",
    delegated: "text-amber-400",
};
function relativeTime(iso) {
    const diff = Date.now() - new Date(iso).getTime();
    if (diff < 60_000)
        return `${Math.round(diff / 1000)}s ago`;
    if (diff < 3_600_000)
        return `${Math.round(diff / 60_000)}m ago`;
    return `${Math.round(diff / 3_600_000)}h ago`;
}
export function AgentActivityDrawer({ open, onClose, events }) {
    return (_jsx(Drawer, { open: open, onClose: onClose, title: "Agent Activity", width: "md", children: events.length === 0 ? (_jsxs("div", { className: "flex flex-col items-center justify-center h-40 text-center", children: [_jsx("span", { className: "text-2xl mb-3 text-slate-700", children: "\u25CE" }), _jsx("p", { className: "text-sm text-slate-500", children: "Agents are idle." }), _jsx("p", { className: "text-xs text-slate-600 mt-1", children: "Background work will appear here." })] })) : (_jsx("div", { className: "space-y-1", children: events.map((ev) => (_jsxs("div", { className: "flex gap-3 py-2.5 border-b border-slate-800/50 last:border-0", children: [_jsx("span", { className: `mt-0.5 text-sm font-mono w-4 shrink-0 ${EVENT_COLORS[ev.event_type]}`, children: EVENT_ICONS[ev.event_type] }), _jsxs("div", { className: "flex-1 min-w-0 space-y-1", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(AgentChip, { agentId: ev.agent_id }), _jsx("span", { className: "text-xs text-slate-600", children: relativeTime(ev.timestamp) }), ev.duration_ms !== undefined && (_jsxs("span", { className: "text-xs text-slate-700", children: [ev.duration_ms, "ms"] }))] }), _jsx("p", { className: "text-xs text-slate-400 leading-relaxed", children: ev.description }), ev.confidence !== undefined && ev.event_type === "completed" && (_jsx(ConfidenceBar, { value: ev.confidence, showLabel: true, className: "max-w-[140px]" }))] })] }, ev.id))) })) }));
}
